







































import {
  computed,
  defineComponent,
  PropType,
  toRefs
} from '~/utils/nuxt3-migration'
import CAvatar from '~/components/shared/configurable/image/avatar/CAvatar.vue'
import { useI18n } from '~/compositions/i18n'
import { defineComponentTranslations } from '~/utils/i18n'
import CImg from '~/components/shared/configurable/image/CImg.vue'
import { ciLocationPin } from '~/icons/source/regular/location-pin'
import { useUserAgent } from '~/compositions/user-agent'
import SpotCheckBadge from '~/components/shared/audits/badges/SpotCheckBadge.vue'
import { AuditShop } from '~/models/audit/shop'

export default defineComponent({
  components: { SpotCheckBadge, CAvatar, CImg },
  props: {
    shop: {
      type: Object as PropType<AuditShop>,
      required: true
    }
  },
  setup(props) {
    const { shop } = toRefs(props)
    const { t } = useI18n()
    const { isMobile } = useUserAgent()

    const allPackagePrices = computed(() => {
      return shop.value.packages.map(p => {
        return p.price
      })
    })
    const minPackagePrice = computed(() => {
      if (allPackagePrices.value.length) {
        return Math.min(...allPackagePrices.value) + ' €'
      }
      return null
    })
    const maxPackagePrice = computed(() => {
      if (allPackagePrices.value.length > 1) {
        return Math.max(...allPackagePrices.value) + ' €'
      }
      return null
    })

    const distance = computed(() => {
      if (!shop.value.distanceFromGeolocation) {
        return null
      }
      const distance: number = parseFloat(
        shop.value.distanceFromGeolocation.toFixed(0)
      )
      return `${distance} ${t('km_away')}`
    })

    return {
      minPackagePrice,
      maxPackagePrice,
      distance,
      ciLocationPin,
      isMobile
    }
  },
  i18n: defineComponentTranslations({
    provider_workshop: {
      en: 'Provider workshop',
      el: 'Συνεργείο Παρόχου'
    }
  })
})
